/* eslint-disable */

// font-size
export const FONT_SIZE = 14;

// noop function
export function noop() {}

// 是否微信浏览器
export function isWeixin() {
  let ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      return true;
  } else {
      return false;
  }
}

// 是否移动端
export function isMobile() {
  let mobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return mobile != null;
}

// return a hashcode
export function hashCode(str){
  var hash = 0;
  if (str.length == 0) return hash;
  for (let i = 0; i < str.length; i ++) {
    let char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
}

// return real length
export function gblen(str) {
  if (!str) return '';
  let length = str.length;
  let gbstr = str.match(/[^\x00-\x80]/g);
  let gblength = gbstr ? gbstr.length : 0;
  return (length - gblength) + (gblength * 2);
}

export const generateId = function() {
  return Math.floor(Math.random() * 10000000);
};

// 校验手机号
export const mobileOk = (mobile) => {
  if (!mobile || !mobile.length) {
    return false;
  }
  return /^1[0-9]\d{9}$/.test(mobile);
}

// return prop by path
export function getPropByPath(obj, path) {
  let tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');

  let keyArr = path.split('.');
  let i = 0;

  for (let len = keyArr.length; i < len - 1; ++i) {
    let key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      throw new Error('please transfer a valid prop path to form item!');
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj[keyArr[i]]
  };
}

// move array
export function moveArr(arr, old_index, new_index) {
  if (old_index < 0 || new_index < 0)
      return arr;
  if (new_index >= arr.length) {
      let k = new_index - arr.length;
      while ((k--) + 1) {
          arr.push(undefined);
      }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
}

// array json to tree
export function arrayToTree(obj, keys = {}) {
  let r = [], temp = [], key = keys['id'] || 'id', parentKey = keys['parentid'] || 'parentid', childKey = keys['children'] || 'children';
  if (!Array.isArray(obj)) return [obj];

  obj.forEach(data => {
    temp[data[key]] = data;
  });
  obj.forEach(data => {
    if (data[parentKey] && temp[data[parentKey]] && data[key] !== data[parentKey]) {
      if (!temp[data[parentKey]][childKey])
        temp[data[parentKey]][childKey] = [];
      temp[data[parentKey]][childKey].push(data);
    } else {
      r.push(data);
    }
  });

  return r;
}

// tree json to array
export function treeToArray(obj, keys) {
  if ((!obj && !Array.isArray(obj)) || !keys) return obj;
  let childkey = keys['children'] || 'children', levelKey = keys['level'] || 'level';
  let array = [];
  let putChild = function(obj, level) {
    level = level || 0;
    if (Array.isArray(obj)) {
      obj.forEach((o) => {
        o[levelKey] = level;
        array.push(o);
        if (o[childkey]) {
          putChild(o[childkey], level + 1);
        }
      });
    } else {
      obj[levelKey] = level;
      array.push(obj);
      if (obj && obj[childkey]) {
        putChild(obj[childkey], level + 1);
      }
    }
  }
  putChild(obj);
  return array;
}

// get max depth for tree data
export const maxDepth = function(root, childKey) {
  let depth = 0;
  let getDeep = function(data, childKey, deep) {
    if (data[childKey]) {
      data[childKey].map((data) => {
        getDeep(data, childKey, deep + 1);
      });
    } else {
      depth = Math.max(depth, deep);
    }
  }
  if (!(root && childKey)) {
    return 0;
  }
  getDeep(root, childKey, 0);
  return depth;
};

// get parent for array
export const getParent = function(data, node, id, parentid, childKey) {
  let parent = null;
  if (!(node[parentid] && parentid)) return node;
  let findParent = function(data) {
    data.map(data => {
      if (data[id] === node[parentid]) {
        parent = data;
        return;
      }
      if (data[childKey]) {
        findParent(data[childKey]);
      }
    })
  };
  findParent(data);
  return parent;
}

export const defaultGridKeys = {
  id: 'id',
  parentid: 'parentid',
  parent: 'parent',
  children: 'children',
  level: 'level',
  order: 'order',
  index: 'jy.grid.index',
  edit: 'jy.grid.edit',
  editing: 'jy.grid.editing',
  changeData: 'jy.grid.changeData',
  drag: 'jy.grid.drag',
  add: 'jy.grid.add',
  temp: 'jy.grid.temp',
  remove: 'jy.grid.remove',
  loading: 'jy.grid.loading',
  collapse: 'jy.grid.collapse',
  expand: 'jy.grid.expand',
  expanding: 'jy.grid.expanding',
  watch: 'jy.grid.watch' // watch flag
};

// dom addClass
export const hasClass = function (el, cls) {
  cls = cls || '';
  if (cls.replace(/\s/g, '').length == 0) return false; //当cls没有参数时，返回false
  return new RegExp(' ' + cls + ' ').test(' ' + el.className + ' ');
}

// dom addClass
export const addClass = function (el, cls) {
  cls.split(',').forEach(cls => {
    cls = cls.trim();
    if (!hasClass(el, cls)) {
      el.className = el.className == '' ? cls : el.className + ' ' + cls;
    }
  });
}

// dom addClass
export const removeClass = function (el, cls) {
  cls.split(',').forEach(cls => {
    cls = cls.trim();
    if (hasClass(el, cls)) {
      let newClass = ' ' + el.className.replace(/[\t\r\n]/g, '') + ' ';
      while (newClass.indexOf(' ' + cls + ' ') >= 0) {
        newClass = newClass.replace(' ' + cls + ' ', ' ');
      }
      el.className = newClass.replace(/^\s+|\s+$/g, '');
    }
  });
}

// get abs point
export const getAbsPoint = (e) => {
  let x = e.offsetLeft;
  let y = e.offsetTop;
  while (e = e.offsetParent) {
    x += e.offsetLeft;
    y += e.offsetTop;
  }
  return {'x': x, 'y': y};
}

// validate rules pattern
export const rulePattern = {
  date: /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])$/,
  datetime: /^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])\s+(20|21|22|23|[0-1]\d):[0-5]\d:[0-5]\d$/,
  email: /^[\w\+\-]+(\.[\w\+\-]+)*@[a-z\d\-]+(\.[a-z\d\-]+)*\.([a-z]{2,4})$/i,
  sfzh: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
}

export const param = (object) => {
  if (!object) {
    return ''
  }

  let str = [];
  Object.keys(object).forEach(key => {
    str.push(key +'='+ (object[key] || ''));
  });

  return str.join('&');
};

// validate number for async-validator
export const validateNumber = (rule, value, callback) => {
  if (value == null || value == '') {
    callback();
  } else {
    if (isNaN(value)) {
      callback(new Error('需要数字！'));
    } else {
      callback();
    }
  }
}

// validate integer for async-validator
export const validateInteger = (rule, value, callback) => {
  if (value == null || value == '') {
    callback();
  } else {
    if (!Number.isInteger(value)) {
      callback(new Error('需要整数！'));
    } else {
      callback();
    }
  }
}

/**
 * el: img DOM || img src
 **/
export const imgSize = (el, zoomW, zoomH) => {
  let img = new Image();
  img.src = typeof(el) === 'object' ? el.src : el;
  let size = { width: img.width, height: img.height };
  let scale = size.width / size.height;
  if (zoomW) {
    if (zoomW < size.width) {
      size.width = zoomW;
      size.height = zoomW / scale;
    }
  }
  if (zoomH) {
    if (zoomH < size.height) {
      size.width = zoomH * scale;
      size.height = zoomH;
    }
  }

  return size;
};

// deep copy object
export const deepCopy = (obj) => {
  let result = Array.isArray(obj) ? [] : {};
  for (let key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (typeof obj[key] === 'object' && obj[key] !== null) {
        result[key] = deepCopy(obj[key]);   //递归复制
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
}

//hex颜色转rgb颜色
export const HexToRgb = (str) => {
  let r = /^\#?[0-9A-F]{6}$/;
  //test方法检查在字符串中是否存在一个模式，如果存在则返回true，否则返回false
  if (!r.test(str)) {
    console.error('输入错误的hex');
    return str;
  }
  //replace替换查找的到的字符串
  str = str.replace('#', '');
  //match得到查询数组
  let hxs = str.match(/../g);
  //alert('bf:'+hxs)
  for (let i = 0; i < 3; i++) hxs[i] = parseInt(hxs[i], 16);
  return hxs;
}

//GRB颜色转Hex颜色
export const RgbToHex = (a, b, c) => {
  let r = /^\d{1,3}$/;
  if (!r.test(a) || !r.test(b) || !r.test(c)) {
    console.error('输入错误的rgb颜色值！');
    return '';
  }
  let hexs = [a.toString(16), b.toString(16), c.toString(16)];
  for (let i = 0; i < 3; i++) if (hexs[i].length == 1) hexs[i] = '0' + hexs[i];
  return '#' + hexs.join('');
}

//得到hex颜色值为color的加深颜色值，level为加深的程度，限0-1之间
export const getDarkColor = (color, level) => {
  var r = /^\#?[0-9A-F]{6}$/;
  if (!r.test(color)) {
    console.error('输入错误的hex颜色值');
    return;
  }
  let rgbc = HexToRgb(color);
  //floor 向下取整
  for (let i = 0; i < 3; i++) rgbc[i] = Math.floor(rgbc[i] * (1 - level));
  return RgbToHex(rgbc[0], rgbc[1], rgbc[2]);
}

//得到hex颜色值为color的减淡颜色值，level为加深的程度，限0-1之间
export const getLightColor = (color, level) => {
  var r = /^\#?[0-9A-F]{6}$/;
  if (!r.test(color)) {
    console.error('输入错误的hex颜色值');
    return;
  }
  let rgbc = HexToRgb(color);
  for (let i = 0; i < 3; i++) rgbc[i] = Math.floor((255 - rgbc[i]) * level + rgbc[i]);
  return RgbToHex(rgbc[0], rgbc[1], rgbc[2]);
}

// ⽣成随机字符串
export const randomGenerate = (length) => {
  const chars = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'A', 'B', 'C', 'D', 'E',
    'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  if (!Number.isInteger(length) || length <= 0) { // 合法性校验
    console.error('请检查输⼊随机字符串长度是否为正整数！');
    return 'Error';
  }
  let randomString = '';
  for (let i = 0; i < length; i++) {
    randomString += chars[Math.floor(Math.random() * chars.length)];
  }
  return randomString;
}